'use client';

import { Switch } from '@coolblue-development/freddy';
import { useState } from 'react';
import { SupportedExperiments } from 'src/constants';

import { toggleExperimentCookie } from './actions/toggleExperimentCookie';

type Props = {
  enabled: boolean;
  name: SupportedExperiments;
};

export default function ExperimentToggle({ enabled, name }: Props) {
  const [checked, setChecked] = useState(enabled);
  const onChange = async () => {
    setChecked(!checked);
    await toggleExperimentCookie(name);

    // Refresh page to prevent error when updating query
    window.location.reload();
  };

  return <Switch checked={checked} onChange={onChange} />;
}
